'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { motion } from 'motion/react';
import Link from 'next/link';
import { Step_useCtx } from './context';
import { useMemo } from 'react';
export default function StepProgressBar(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Step_useCtx();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const stepCtx = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = stepCtx.state.map(_temp).reduce(_temp2, 0);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const avgLabelLength = t2 / stepCtx.state.length;
  let t3;
  if ($[2] !== className) {
    t3 = cx("isolate w-full", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="pointer-events-none absolute left-3 right-3 top-3 h-0.5 bg-brown-200 sm:left-3.5 sm:right-3.5 sm:top-3.5" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      scaleX: 0
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <nav><div className="relative flex items-start justify-between px-4">{t4}<motion.div className="pointer-events-none absolute left-3 right-3 top-3 h-0.5 origin-left bg-secondary sm:left-3.5 sm:right-3.5 sm:top-3.5" initial={t5} animate={{
          scaleX: stepCtx.currentIdx === 0 ? 0 : stepCtx.currentIdx / (stepCtx.state.length - 1)
        }} />{stepCtx.state.map((step, i) => {
          const prevStep = stepCtx.getStepByIdx(i - 1);
          const isAccessible = prevStep === undefined || prevStep.isCompleted === true;
          const isCompleted = i < stepCtx.currentIdx;
          const isCurrent = i === stepCtx.currentIdx;
          return <div key={step.path} className="relative z-[1] flex flex-col items-center" style={{
            width: 0,
            overflow: "visible"
          }}><Link href={step.href} onClick={e => !isAccessible && e.preventDefault()} className={cx("flex flex-col items-center gap-1.5", !isAccessible && "cursor-not-allowed")}><span className={cx("flex h-6 w-6 items-center justify-center rounded-full text-[10px] font-bold transition-colors sm:h-7 sm:w-7 sm:text-xs", isCompleted && "bg-secondary text-white", isCurrent && "bg-secondary text-white", !isCompleted && !isCurrent && "bg-brown-200 text-brown-500")}>{i + 1}</span><span className={cx("whitespace-nowrap text-center text-[10px] font-medium leading-tight sm:text-xs", isCompleted && "text-secondary", isCurrent && "font-bold text-secondary", !isCompleted && !isCurrent && "text-brown-500", !isCurrent && avgLabelLength > 15 && stepCtx.state.length > 3 && "max-sm:hidden")}>{step.label}</span></Link></div>;
        })}</div></nav>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3) {
    t7 = <header className={t3}>{t6}</header>;
    $[7] = t3;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}
function _temp2(acc, length) {
  acc = acc + length;
  return acc;
}
function _temp(x) {
  return x.label.length;
}